import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, User } from 'lucide-react';
import { Card, CardContent } from 'components/ui/card';
import { Button } from 'components/ui/button';
import { formatEventDateRange } from 'utility/dateFormatting';

export default function EventListItem(props) {
    const e = props.event;
    const { i18n } = useLingui();

    const dateString = formatEventDateRange(e.start_date, e.end_date, i18n.locale);

    return (
        <div className="transition-transform duration-300 hover:scale-[1.03] h-full group">
            <Card className="overflow-hidden flex flex-col h-full border-solid border-border shadow-none">
                <Link to={`/event/${e.event_id}`} className="block overflow-hidden">
                    {e.image_url !== null && (
                        <img
                            alt={e.event_title}
                            src={e.image_url}
                            className="w-full aspect-[2/1] object-cover transition-transform duration-300 group-hover:scale-[1.08]"
                        />
                    )}
                </Link>

                <CardContent className="flex flex-col flex-1 p-4 pt-4">
                    <h2 className="text-lg font-bold text-foreground mb-2">{e.event_title}</h2>

                    <div className="flex items-center gap-1.5 mb-1">
                        <Calendar size={16} className="text-primary shrink-0" aria-hidden />
                        <span className="text-sm text-primary">{dateString}</span>
                    </div>

                    <div className="flex items-center gap-1.5 mb-1">
                        <MapPin size={16} className="text-muted-foreground shrink-0" aria-hidden />
                        <span className="text-sm text-muted-foreground">
                            {e.city}, {e.prov_state}
                        </span>
                    </div>

                    {props.includeHostLink && (
                        <Link
                            to={`/host/${e.host_id}`}
                            className="inline-flex self-start items-center gap-1.5 mb-1 no-underline"
                        >
                            <User
                                size={16}
                                className="text-muted-foreground shrink-0"
                                aria-hidden
                            />
                            <span className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                                <Trans>Hosted by</Trans> {e.host_name}
                            </span>
                        </Link>
                    )}

                    <div className="mt-auto pt-4">
                        <Link to={`/event/${e.event_id}`} className="no-underline">
                            <Button className="rounded-md font-bold uppercase tracking-wide">
                                <Trans>Buy Tickets</Trans>
                            </Button>
                        </Link>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
